import { ActionType } from '../../constants/ActionTypes'

export default function reportReducer(state = {}, action) {

    switch (action.type) {
        // Get Reports For Payment
        case ActionType.GET_PAYMENT_REPORT_BEGIN:
            return {
                ...state,
                inProcess: true,
            };

        case ActionType.GET_PAYMENT_REPORT_SUCCESS:
            return {
                ...state,
                inProcess: false,
                paymentReport: action.payload.Data,
            }

        case ActionType.GET_PAYMENT_REPORT_ERROR:
            return {
                ...state,
                inProcess: false,
                paymentReport: action.payload.Data,
            }

        // Get Reports For Games
        case ActionType.GET_REPORT_FOR_AFFILIATE_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.GET_REPORT_FOR_AFFILIATE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                gameReport: action.payload.Data,
            }

        case ActionType.GET_REPORT_FOR_AFFILIATE_ERROR:
            return {
                ...state,
                inProcess: false,
                gameReport: action.payload.Data,
            }

        // Get Reports Game Providers
        case ActionType.GET_REPORT_OPERATION_TYPE_BEGIN:
            return {
                ...state,
            };

        case ActionType.GET_REPORT_OPERATION_TYPE_SUCCESS:
            return {
                ...state,
                gameProvider: action.payload.Data,
            }

        case ActionType.GET_REPORT_OPERATION_TYPE_ERROR:
            return {
                ...state,
                gameProvider: action.payload.Data,
            }

        // Get Report Payments
        case ActionType.GET_REPORT_PAYMENTS_BEGIN:
            return {
                ...state,
            };

        case ActionType.GET_REPORT_PAYMENTS_SUCCESS:
            return {
                ...state,
                reportPayments: action.payload.Data,
            }

        case ActionType.GET_REPORT_PAYMENTS_ERROR:
            return {
                ...state,
                reportPayments: action.payload.Data,
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/mainAffilate/ReportsReducer.js